import script from "./OrderForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderForm.vue?vue&type=script&setup=true&lang=ts"

import "./OrderForm.vue?vue&type=style&index=0&id=fdc7a9c2&scoped=true&lang=css"
script.__scopeId = "data-v-fdc7a9c2"

export default script